import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { apiPost } from '../../utils/api';
import { Button, Card, Input, Spinner } from '../design-system';
import { toast } from 'react-hot-toast';
import { ArrowLeft, Info } from 'lucide-react';

const JoinPracticeForm = ({ onSuccess, onCancel }) => {
  const { user, refreshUserInfo } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [orgId, setOrgId] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await apiPost('/.netlify/functions/create-join-request', {
        orgId: orgId.trim().toUpperCase()
      }, user);

      if (response.message && response.message.includes('Successfully joined')) {
        toast.success('Successfully joined practice!');
        if (refreshUserInfo) {
          await refreshUserInfo();
        }
        if (onSuccess) {
          onSuccess(response);
        }
      } else {
        toast.success('Join request submitted. The admin will review your request.');
        // Refresh user info to update practice status
        if (refreshUserInfo) {
          await refreshUserInfo();
        }
        if (onSuccess) {
          onSuccess(response);
        }
      }
    } catch (error) {
      console.error('Error joining practice:', error);
      toast.error(error.message || 'Failed to join practice');
      setIsLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: 'var(--color-background)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: 'var(--space-8) var(--space-4)'
    }}>
      <Card variant="default" padding="large" style={{ maxWidth: '500px', width: '100%' }}>
        {onCancel && (
          <Button
            variant="ghost"
            onClick={onCancel}
            style={{ marginBottom: 'var(--space-4)' }}
          >
            <ArrowLeft size={16} style={{ marginRight: 'var(--space-2)' }} />
            Back
          </Button>
        )}

        <h2 style={{ 
          fontSize: 'var(--text-h2)', 
          fontWeight: 'var(--weight-bold)', 
          color: 'var(--color-text)',
          marginBottom: 'var(--space-2)'
        }}>
          Enter Practice ID
        </h2>
        <p style={{ 
          fontSize: 'var(--text-body)', 
          color: 'var(--color-text)', 
          opacity: 0.7,
          marginBottom: 'var(--space-6)'
        }}>
          Your practice admin can provide you with the Practice ID
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
          <div>
            <label style={{ 
              display: 'block', 
              fontSize: 'var(--text-caption)', 
              fontWeight: 'var(--weight-semibold)', 
              color: 'var(--color-text)',
              marginBottom: 'var(--space-2)'
            }}>
              Practice ID *
            </label>
            <Input
              type="text"
              value={orgId}
              onChange={(e) => setOrgId(e.target.value.toUpperCase())}
              required
              placeholder="PRACTICE-ABC123"
              style={{ 
                textTransform: 'uppercase',
                fontFamily: 'monospace',
                fontSize: 'var(--text-h3)',
                letterSpacing: '0.05em'
              }}
            />
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 'var(--space-2)',
              marginTop: 'var(--space-2)',
              fontSize: 'var(--text-caption)',
              color: 'var(--color-text)',
              opacity: 0.6
            }}>
              <Info size={14} />
              <span>Don't have a Practice ID? Contact your practice admin.</span>
            </div>
          </div>

          <Button
            type="submit"
            variant="primary"
            size="large"
            disabled={isLoading || !orgId.trim()}
            style={{ marginTop: 'var(--space-4)' }}
          >
            {isLoading ? (
              <>
                <Spinner size="small" />
                <span style={{ marginLeft: 'var(--space-2)' }}>Processing...</span>
              </>
            ) : (
              'Continue'
            )}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default JoinPracticeForm;

